import { logInfo } from './logging';
import { getStoreCurrency } from '@jbhi-fi/utils/src/shopify/getStoreCurrency';
import { trackCheckoutTriggered } from '@jbhi-fi/utils/src/ga4Tracking/functions/trackCheckoutTriggered';
import { waitForElement } from './waitForElement';

let paymentMethod = '';

window.gtm.algoliaIsInit = false;

const addNotSetForUndefPropValues = products => {
  products.forEach(product => {
    let hasDimension3 = false;
    if (product) {
      for (const key in product) {
        if (key === 'dimension3') {
          hasDimension3 = true;
        }
      }
      if (!hasDimension3) {
        product.dimension3 = '(not set)';
      }
    }
    for (const key in product) {
      if ((product.hasOwnProperty(key) && product[key] === undefined) || product[key] === '' || product[key] === null) {
        product[key] = '(not set)';
      }
    }
  });
  return products;
};

window.gtm.track = async (action, customData, isInit = false, isSearch = false) => {
  let data = {};

  if (customData && customData.products) {
    customData.products = addNotSetForUndefPropValues(customData.products);
  }
  if (window.gtm.products) {
    window.gtm.products = addNotSetForUndefPropValues(window.gtm.products);
  }
  if (window.gtm.cartProducts) {
    window.gtm.cartProducts = addNotSetForUndefPropValues(window.gtm.cartProducts);
  }

  if (action) {
    const loginPageForm = document.querySelector('#CustomerLoginForm form');
    if (loginPageForm && window.theme.isCustomerLoggedIn === false) {
      loginPageForm.addEventListener('submit', function () {
        const updatedData = {
          event: 'checkoutOption',
          ecommerce: {
            checkout_option: {
              actionField: {
                step: '2',
                option: 'Login',
              },
            },
          },
        };

        logInfo(updatedData, 'GTM dataLayer updated');
        dataLayer.push(updatedData);
      });
    }

    const registerPageForm = document.querySelector('#registerForm form');
    if (registerPageForm && window.theme.isCustomerLoggedIn === false) {
      registerPageForm.addEventListener('submit', function () {
        const updatedData = {
          event: 'checkoutOption',
          ecommerce: {
            checkout_option: {
              actionField: {
                step: '2',
                option: 'Create Account',
              },
            },
          },
        };

        logInfo(updatedData, 'GTM dataLayer updated');
        dataLayer.push(updatedData);
      });
    }

    switch (action) {
      case 'productView': {
        data = {
          event: 'productView',
          ecommerce: {
            currencyCode: getStoreCurrency(),
            detail: {
              actionField: {
                list: 'productdetails',
              },
              products: addNotSetForUndefPropValues([window.gtm.product]),
            },
          },
        };

        // We also want to push the "Related products" impression (if they exist)
        if (window.gtm.products && window.gtm.products.length) {
          window.gtm.track('productImpression');
        }
        break;
      }

      case 'productClick': {
        let listProducts;
        if (customData.products && customData.products.length) {
          listProducts = customData.products;
        } else if (window.gtm.product && window.gtm.product.id == customData.productSku) {
          listProducts = [window.gtm.product];
        } else {
          for (let i = 0; window.gtm.products.length > i; i++) {
            const product = window.gtm.products[i];
            if (product.id == customData.productSku) {
              product.position = i + 1;
              listProducts = [product];
              break;
            }
          }
        }
        if (listProducts.length) {
          let productsList = 'other';
          if (customData.productsList) {
            productsList = customData.productsList;
          } else if (window.gtm.productsList) {
            productsList = window.gtm.productsList;
          } else if (window.gtm.wishlist) {
            productsList = window.gtm.wishlist;
          }
          productsList = isSearch ? 'search' : productsList;
          data = {
            event: action,
            ecommerce: {
              currencyCode: getStoreCurrency(),
              click: {
                actionField: {
                  list: productsList,
                },
                products: listProducts,
              },
            },
          };
        }
        break;
      }

      case 'addToCart': {
        let listProducts;
        if (customData.products && customData.products.length) {
          listProducts = customData.products;
        } else if (window.gtm.product && window.gtm.product.id == customData.productSku) {
          listProducts = [window.gtm.product];
        } else {
          for (let i = 0; window.gtm.products.length > i; i++) {
            const product = window.gtm.products[i];
            if (product.id == customData.productSku) {
              product.position = i + 1;
              listProducts = [product];
              break;
            }
          }
        }
        if (listProducts.length) {
          let productsList = 'other';
          if (customData.productsList) {
            productsList = customData.productsList;
          } else if (window.gtm.productsList) {
            productsList = window.gtm.productsList;
          } else if (window.gtm.wishlist) {
            productsList = window.gtm.wishlist;
          }
          productsList = isSearch ? 'search' : productsList;
          data = {
            event: action,
            ecommerce: {
              currencyCode: getStoreCurrency(),
              add: {
                actionField: {
                  list: productsList,
                },
                products: listProducts,
              },
            },
          };
        }
        break;
      }

      // When the 'View Cart' page is loaded, please call the dataLayer code after the GTM code
      case 'cartPage': {
        data = {
          event: 'checkoutStep',
          ecommerce: {
            currencyCode: getStoreCurrency(),
            checkout: {
              // checkout step action
              actionField: {
                step: '1',
              },
              products: window.gtm.cartProducts,
            },
          },
        };
        break;
      }

      // When a user successfully creates a new account, please call the following dataLayer.push() code.
      case 'newAccount': {
        if (document.referrer != undefined && document.referrer.indexOf('/register') !== -1) {
          data = {
            event: 'registrationSuccess',
          };
        }
        break;
      }

      case 'productImpression': {
        let products = customData && customData.products ? customData.products : window.gtm.products;
        let algoliaData = customData && customData.algolia ? customData.algolia : {};
        products =
          products &&
          products.map((product, idx) => {
            if (!product.position) {
              if (algoliaData.resultsperpage > 0 && algoliaData.page > 0) {
                product.position = idx + 1 + (algoliaData.page - 1) * algoliaData.resultsperpage;
              } else {
                product.position = idx + 1;
              }
            }
            if (!product.list) {
              product.list = window.gtm.productsList ? window.gtm.productsList : 'other';
            }

            return product;
          });
        data = {
          event: 'productImpression',
          algolia: algoliaData,
          ecommerce: {
            currencyCode: getStoreCurrency(),
            impressions: products,
          },
        };
        break;
      }

      case 'algoliaSearchResults': {
        let products = customData && customData.products ? customData.products : window.gtm.products;
        products =
          products &&
          products.map((product, idx) => {
            product.list = 'search';
            return product;
          });
        data = {
          event: 'algoliaSearchResults',
          algolia: customData.algolia,
          ecommerce: {
            currencyCode: getStoreCurrency(),
            impressions: products,
          },
        };
        break;
      }
      case 'customEvent': {
        data = {
          event: 'sendEvent',
          eventCategory: customData.category ? customData.category : '',
          eventAction: customData.action ? customData.action : '',
          eventLabel: customData.label ? customData.label : '',
        };
        break;
      }
    }
  }

  // Do we need to add pageType?
  if (window.gtm.pageType && isInit) {
    data.pageType = window.gtm.pageType;
  }

  /**
   * Send the analytics event using requestIdleCallback as a non critical event that impedes the main thread.
   * It waits for when the browser is idle to execute the function without impacting critical work such as
   * animations or input response.
   * Takes an object with a timeout property which determines that if the browser hasn't become idle and fired the function in that
   * period, to run the function anyway thus guaranteeing it gets executed.
   *
   * If requestIdleCallback is not defined, execute the function immediately as normal.
   * https://developer.mozilla.org/en-US/docs/Web/API/Window/requestIdleCallback
   */
  const sendTracking = () => window.gtm.customTrack(data);

  typeof window.requestIdleCallback === 'function'
    ? window.requestIdleCallback(sendTracking, { timeout: 4000 })
    : sendTracking();
};

// Login and Register Page GTM events
const loginPage = document.getElementById('loginForm');
const loginFormContainer = document.getElementById('CustomerLoginForm');
const loginPageForm = document.getElementById('customer_login');
const loginPageErrors = document.querySelector('#CustomerLoginForm .errors');
const recoverPasswordErrors = document.querySelector('#RecoverPasswordForm .errors');
const loginLocalStorage = window.localStorage.getItem('user-has-logged-in');
const forgotPasswordLink = document.getElementById('RecoverPassword');
const recoverPasswordForm = document.getElementById('RecoverPasswordForm');
const hideRecoveryPasswordForm = document.getElementById('HideRecoverPasswordLink');
const recoveryPasswordSuccess = document.getElementById('ResetSuccess');
const resetPasswordLocalStorage = window.localStorage.getItem('reset-password-page');
const createAccountBtn = document.querySelector('[data-toggle="registerForm"]');
const loginBtn = document.querySelector('[data-toggle="loginForm"]');
const registerFormContainer = document.getElementById('registerForm');
const registerForm = document.getElementById('create_customer');
const registerFormErrors = document.querySelector('#registerForm .errors');

// Login Page view event
if (
  loginPage &&
  loginPage.classList.contains('isHidden') === false &&
  loginFormContainer &&
  loginFormContainer.classList.contains('hide') === false &&
  !loginPageErrors &&
  location.hash === ''
) {
  const gtmData = {
    event: 'sendPageview',
    pagePath: '/account/login#login',
    pageTitle: 'Log in',
  };

  logInfo(gtmData, 'login page view send to GTM');
  dataLayer.push(gtmData);

  if (loginLocalStorage) {
    window.localStorage.removeItem('user-has-logged-in');
  }

  loginPageForm.addEventListener('submit', function () {
    window.localStorage.setItem('user-has-logged-in', 'true');
  });
}

if (loginBtn) {
  loginBtn.addEventListener('click', function () {
    const gtmData = {
      event: 'sendPageview',
      pagePath: '/account/login#login',
      pageTitle: 'Log in',
    };

    logInfo(gtmData, 'login page view send to GTM');
    dataLayer.push(gtmData);

    if (loginLocalStorage) {
      window.localStorage.removeItem('user-has-logged-in');
    }
  });
}

if (hideRecoveryPasswordForm) {
  hideRecoveryPasswordForm.addEventListener('click', function () {
    const gtmData = {
      event: 'sendPageview',
      pagePath: '/account/login#login',
      pageTitle: 'Log in',
    };

    logInfo(gtmData, 'login page view send to GTM');
    dataLayer.push(gtmData);

    if (loginLocalStorage) {
      window.localStorage.removeItem('user-has-logged-in');
    }
  });
}

// Forgot Password success event
if (loginPage && recoveryPasswordSuccess && recoveryPasswordSuccess.classList.contains('hide') === false) {
  const gtmData = {
    event: 'forgotPasswordSuccess',
  };

  logInfo(gtmData, 'forgot password success send to GTM');
  dataLayer.push(gtmData);

  if (loginLocalStorage) {
    window.localStorage.removeItem('user-has-logged-in');
  }
}

// Login , Register, Forgot Password Error events
if (loginPageErrors || recoverPasswordErrors || registerFormErrors) {
  let pageErrorElem = '';
  if (loginPageErrors) {
    pageErrorElem = loginPageErrors.querySelector('ul li');
  }

  if (recoverPasswordErrors) {
    pageErrorElem = recoverPasswordErrors.querySelector('ul li');
  }

  if (registerFormErrors) {
    pageErrorElem = registerFormErrors.querySelector('ul li');
  }
  let errorType = 'Login';
  if (recoverPasswordForm && recoverPasswordErrors) {
    errorType = 'Forgot Password';
  }
  if (registerFormContainer && registerFormErrors) {
    errorType = 'Registration';
  }
  if (pageErrorElem) {
    const gtmData = {
      event: 'errorEvent',
      errorType,
      errorMsg: pageErrorElem.innerHTML,
    };

    logInfo(gtmData, 'login page error sent to GTM');
    dataLayer.push(gtmData);

    if (loginLocalStorage) {
      window.localStorage.removeItem('user-has-logged-in');
    }
  }
}

// Forgot Password Page view event
if (loginPage && forgotPasswordLink) {
  forgotPasswordLink.addEventListener('click', function () {
    const gtmData = {
      event: 'sendPageview',
      pagePath: '/account/login#recover',
      pageTitle: 'Forgot Password',
    };

    logInfo(gtmData, 'send forgot password page view to GTM');
    dataLayer.push(gtmData);
  });
}

if (recoverPasswordForm && location.hash === '#recover' && !recoverPasswordErrors) {
  const gtmData = {
    event: 'sendPageview',
    pagePath: '/account/login#recover',
    pageTitle: 'Forgot Password',
  };

  logInfo(gtmData, 'send forgot password page view to GTM');
  dataLayer.push(gtmData);
}

// Login Success
if (!loginPage && loginLocalStorage) {
  const gtmData = {
    event: 'loginSuccess',
  };

  logInfo(gtmData, 'Log in success sent to GTM');
  dataLayer.push(gtmData);

  window.localStorage.removeItem('user-has-logged-in');
}

// Reset Password Success
if (resetPasswordLocalStorage) {
  const gtmData = {
    event: 'resetPasswordSuccess',
  };

  logInfo(gtmData, 'Reset password success sent to GTM');
  dataLayer.push(gtmData);

  window.localStorage.removeItem('reset-password-page');
}

// Registration Page view event
if (createAccountBtn) {
  createAccountBtn.addEventListener('click', function () {
    const gtmData = {
      event: 'sendPageview',
      pagePath: '/account/login#registration',
      pageTitle: 'Registration',
    };

    logInfo(gtmData, 'registration page view send to GTM');
    dataLayer.push(gtmData);

    if (loginLocalStorage) {
      window.localStorage.removeItem('user-has-logged-in');
    }
  });
}

if (registerFormContainer && registerFormContainer.classList.contains('isHidden') === false && !registerFormErrors) {
  const gtmData = {
    event: 'sendPageview',
    pagePath: '/account/login#registration',
    pageTitle: 'Registration',
  };

  logInfo(gtmData, 'registration page view send to GTM');
  dataLayer.push(gtmData);

  if (loginLocalStorage) {
    window.localStorage.removeItem('user-has-logged-in');
  }
}

// Registration success event
if (registerForm) {
  registerForm.addEventListener('submit', function (event) {
    window.localStorage.setItem('register-form', 'true');
  });
}

if (!registerFormContainer && !registerForm && window.localStorage.getItem('register-form')) {
  const gtmData = {
    event: 'registrationSuccess',
  };

  dataLayer.push(gtmData);
  window.localStorage.removeItem('register-form');
}

// Password reset page GTM events
const resetPasswordPage = document.getElementById('ResetPasswordForm');
if (resetPasswordPage) {
  const resetPasswordLocalStorage = window.localStorage.getItem('reset-password-page');
  const loginPageErrors = document.querySelector('.errors');
  const resetPasswordForm = document.querySelector('#ResetPasswordForm form');
  if (resetPasswordForm) {
    resetPasswordForm.addEventListener('submit', function () {
      window.localStorage.setItem('reset-password-page', 'true');
    });
  }
  if (!loginPageErrors) {
    const gtmData = {
      event: 'sendPageview',
      pagePath: '/account/reset',
      pageTitle: 'Forgot Password',
    };

    logInfo(gtmData, 'reset password page view send to GTM');
    dataLayer.push(gtmData);

    if (resetPasswordLocalStorage) {
      window.localStorage.removeItem('reset-password-page');
    }
  }

  if (loginPageErrors) {
    const loginPageErrorElem = loginPageErrors.querySelector('ul li');
    const errorType = 'Reset Password';

    if (loginPageErrorElem) {
      const gtmData = {
        event: 'errorEvent',
        errorType,
        errorMsg: loginPageErrorElem.innerHTML,
      };

      logInfo(gtmData, 'login page error sent to GTM');
      dataLayer.push(gtmData);

      if (resetPasswordLocalStorage) {
        window.localStorage.removeItem('reset-password-page');
      }
    }
  }
}

if (window.location.pathname === '/cart') {
  const cartSelector = '.cart [data-cart-total] .checkout-btns div.checkout-btn [data-cart-continue-btn]';
  waitForElement(
    cartSelector,
    element => {
      element.addEventListener('click', () => {
        trackCheckoutTriggered({ triggerSource: 'my_cart' });
      });
    },
    '#MainContent',
    true
  );
}

// Checkout login button GTM EVENT
document.addEventListener('DOMContentLoaded', function () {
  const checkoutLoginBtn = document.querySelector('.login-option-box a.btn');
  if (checkoutLoginBtn) {
    checkoutLoginBtn.addEventListener('click', function () {
      const gtmData = {
        event: 'sendEvent',
        eventCategory: 'Enhanced Ecommerce',
        eventAction: 'Login',
      };

      dataLayer.push(gtmData);
    });
  }
});

const calculatePaymentMethod = () => {
  const paymentOptionsRadio = document.querySelectorAll('[data-payment-method] .radio__input .input-radio');
  const giftCardElement = document.querySelector('.gc-label');

  paymentMethod = 'Credit or debit card';

  if (
    paymentOptionsRadio &&
    paymentOptionsRadio.length > 0 &&
    !paymentOptionsRadio[0].parentElement.parentElement.parentElement.parentElement.classList.contains('hidden')
  ) {
    for (let i = 0; i < paymentOptionsRadio.length; i++) {
      if (paymentOptionsRadio[i].checked) {
        let paymentOptionLabel = paymentOptionsRadio[i].parentElement.parentElement.querySelector(
          '.radio__label label span.visually-hidden'
        );
        if (paymentOptionLabel) {
          paymentMethod = paymentOptionLabel.innerHTML.trim();
        } else {
          paymentOptionLabel = paymentOptionsRadio[i].parentElement.parentElement.querySelector('.radio__label label');
          if (paymentOptionLabel) {
            paymentMethod = paymentOptionLabel.innerHTML.trim();
          }
        }
      }
    }
  }

  if (giftCardElement) {
    paymentMethod += ',Gift card';
    document.querySelectorAll('.content-box__row')?.forEach(el => {
      if (el && el.lastElementChild.innerHTML === 'Your order is covered by your gift card.' && el.offsetParent) {
        paymentMethod = 'Gift card';
      }
    });
  }

  paymentMethod = paymentMethod.replace(/(^,)|(,$)/g, '');
};

window.gtm.customTrack = data => {
  if (data) {
    logInfo(data, 'GTM analytics push');
    dataLayer.push(data);
  }
};

// If window.gtm was built before this file was loaded, track this, otherwise we'll call window.gtm.customTrack() when it loads.
if (!window.gtm.initialized) {
  if (window.gtm.pageloadAction) {
    window.gtm.track(window.gtm.pageloadAction);
  } else if (window.gtm.customData) {
    window.gtm.track(window.gtm.customData);
  }
}

// Klaviyo GTM Events
const klaviyoNotifyButton = document.querySelector('.klaviyo-bis-trigger');

if (klaviyoNotifyButton) {
  klaviyoNotifyButton.addEventListener('click', event => {
    const gtmData = {
      event: 'productStartNotifyMe',
      ecommerce: {
        products: addNotSetForUndefPropValues([window.gtm.product]),
      },
    };
    logInfo(gtmData, 'GTM dataLayer pushed');
    dataLayer.push(gtmData);

    // Set timeout in order for Kalviyo to populate the iFrame content (0.5s)
    setTimeout(() => {
      let klaviyoiFrame = document.querySelector('#klaviyo-bis-iframe');
      klaviyoiFrame = klaviyoiFrame.contentDocument || klaviyoiFrame.contentWindow.document; // iFrame content

      klaviyoiFrame.querySelectorAll('.form-horizontal')[0].addEventListener('submit', event => {
        // Observer to watch for style changes
        const observer = new MutationObserver((mutations, observer) => {
          // If the completed_message displays
          if (mutations && mutations[0].target.id === 'completed_message') {
            const gtmData = {
              event: 'productSuccessNotifyMe',
              action: klaviyoiFrame.querySelectorAll('#subscribe_for_newsletter')[0].checked,
              ecommerce: {
                products: addNotSetForUndefPropValues([window.gtm.product]),
              },
            };
            logInfo(gtmData, 'GTM dataLayer pushed');
            dataLayer.push(gtmData);
            observer.disconnect();

            // If the error_message displays
          } else if (mutations && mutations[0].target.id === 'error_message') {
            const gtmData = {
              event: 'productFailureNotifyMe',
              ecommerce: {
                products: addNotSetForUndefPropValues([window.gtm.product]),
              },
            };
            logInfo(gtmData, 'GTM dataLayer pushed');
            dataLayer.push(gtmData);
            observer.disconnect();
          }
        });

        const completed_message = klaviyoiFrame.querySelectorAll('#completed_message')[0];
        observer.observe(completed_message, { attributes: true, attributeFilter: ['style'] });

        const error_message = klaviyoiFrame.querySelectorAll('#error_message')[0];
        observer.observe(error_message, { attributes: true, attributeFilter: ['style'] });
      });
    }, 500);
  });
}
